import * as api from '../../requests'
import ls from 'local-storage'
import shortid from 'shortid'

export const setActiveCategory = category => dispatch => {
  dispatch({
    type: '@@mr/SET_ACTIVE_CATEGORY',
    category
  })
  dispatch({
    type: 'SET_CURRENT_CATEGORY',
    category
  })
}

export const setMyRecords = (results, category) => ({
  type: 'SET_MY_RECORDS',
  results,
  category
})

export const pullAndSetMyRecords = category => (dispatch, getState) => {
  dispatch(setRecordsLoading(true))
  dispatch(setRecordsError(false))
  dispatch(setRecordsErrorDetails({ message: null, code: null }))
  const parameters = getState().myRecords.filters[category] || {}
  const requestId = shortid.generate()
  dispatch(setLastRequestId(requestId))
  api.GET_MY_RECORDS(
    category,
    parameters,
    requestId,
    (data, props = {}) => {
      if (getState().myRecords.lastRequestId === props.requestId) {
        dispatch(setMyRecords(data, category))
        dispatch(setRecordsLoading(false))
      }
    },
    err => {
      dispatch(setRecordsLoading(false))
      dispatch(setRecordsError(true))
      dispatch(setRecordsErrorDetails({ message: err.Message, code: err.Code }))
    }
  )
}

export const selectMyRecordsRow = (category, selected) => ({
  type: 'SELECT_MY_RECORDS_ROW',
  selected,
  category
})

export const setMyRecordsSelectedDetails = details => ({
  type: 'SET_MY_RECORDS_SELECTED_DETAILS',
  details
})

export const setMyRecordsResultsMode = mode => ({
  type: 'SET_MY_RECORDS_RESULTS_MODE',
  mode
})

export const setRecordDetailsLoading = loading => ({
  type: 'SET_RECORD_DETAILS_LOADING',
  loading
})

export const selectMyRecordsRowAndGetDetails = (category, id, callback) => dispatch => {
  dispatch(selectMyRecordsRow(category, id))
  // if (id !== null) {
  //   console.log("selectMyRecordsRowAndGetDetails HIT")
  //  
  //   api.GET_FILING_DETAILS(
  //     category,
  //     id,
  //     false,
  //     () => {},
  //     data => {
  //       dispatch(setMyRecordsSelectedDetails(data.DRAWER_DETAIL_LIST))
  //         console.log(store.getState())
  //       console.log(data)
  //       console.log(callback)
  //       if (callback) {
  //         callback(data)
  //       }
  //     }
  //   )
  // }
}

export const setSelectedOwnershipRecords = records => ({
  type: 'SET_MY_RECORDS_SELECTED_OWNERSHIP_RECORDS',
  selectedOwnershipRecords: records
})

export const fetchAndSetSelectedOwnershipRecords = (
  sourceTypeId,
  sourceId,
  callback
) => dispatch => {
  api.GET_WEB_USER_ACCESS_LIST(sourceTypeId, sourceId, records => {
    dispatch(setSelectedOwnershipRecords(records))
    if (callback) {
      callback(records)
    }
  })
}

export const setFilters = (category, filters) => (dispatch, getState) => {
  dispatch({
    type: '@@mr/SET_FILTERS',
    category,
    filters
  })
  ls.set('MY_RECORDS_FILTERS', { ...getState().myRecords.filters, [category]: filters })
}

export const setRecordsLoading = loading => ({
  type: 'SET_MY_RECORDS_LOADING',
  loading
})

export const setRecordsError = error => ({
  type: 'SET_MY_RECORDS_ERROR',
  error
})

export const setRecordsErrorDetails = errorDetails => {
  return {
    type: 'SET_MY_RECORDS_ERROR_DETAILS',
    errorDetails
  }
}

export const setLastRequestId = requestId => ({
  type: '@@mr/SET_REQUEST_ID',
  requestId
})

export const invalidateAllCategoryCaches = () => dispatch => {
  dispatch({
    type: '@@mr/INVALIDATE_CACHE'
  })
}



// WEBPACK FOOTER //
// ./src/components/MyRecords/MyRecordsActions.js